import Vue from 'vue';
import { throttle } from 'throttle-debounce';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { mapGetters } from 'vuex';
import cleanObject from '../utils/cleanObject';

// Отдельный реактивный vue инстанс для управления
// состояниями ui и прочими глобальными настройками
export default {
  install: (App, options) => {
    App.prototype.$f = new Vue({
      ...options,
      data() {
        return {
          windowDimensions: [1080, 800],
          navActive: false,
          navSection: '',
          isAuthShown: false,
          authData: null,
          isSearchShown: false,

          // account просмотр старых заказов
          currentOrderNumber: '',
          orderOpened: false,
        };
      },
      computed: {
        ...mapGetters({
          LOGGED_IN: 'user/loggedIn',
        }),
        navOpened() {
          return !this.$options?.adaptive.isDesktop && this.navActive;
        },
      },
      watch: {
        '$route.hash'(hash) {
          switch (hash) {
            case '#register':
              if (this.LOGGED_IN) {
                this.$store.dispatch('notifications/create', {
                  title: 'Вы уже авторизованы!',
                  type: 'success'
                });
                this.$router.replace({ hash: '' });
                break;
              }
              this.login()
                .then(() => {})
                .catch(() => {})
                .finally(() => {
                  this.$router.replace({ hash: '' });
                });
                break;
            default: break;
          }
        }
      },
      methods: {
        initClient() {
          // запускаем в главном mounted, иначе несовпадение нод
          this.setDimensions();
          window.addEventListener('resize', throttle(200, this.setDimensions));
        },

        showNav(section = '') {
          clearAllBodyScrollLocks();
          this.navSection = section;
          this.navActive = true;
          this.$nextTick(() => {
            const scrollableElm = document.querySelector('.tree-menu .active > div') || document.querySelector('.tree-menu');
            if (scrollableElm) disableBodyScroll(scrollableElm);
          });
        },

        hideNav() {
          this.navActive = false;
          this.navSection = '';
          clearAllBodyScrollLocks();
        },

        setDimensions() {
          this.windowDimensions = [window.innerWidth, window.innerHeight];
        },

        login(data) {
          if (this.LOGGED_IN) return Promise.resolve();
          return new Promise((resolve, reject) => {
            this.authData = data;
            this.isAuthShown = true;
            this.$on('login', () => {
              this.authData = null;
              this.isAuthShown = false;
              this.$off('login');
              resolve();
            });
            this.$on('login:close', () => {
              this.authData = null;
              this.isAuthShown = false;
              this.$off('login:close');
              reject();
            });
          });
        },

        toggleSearch() {
          !this.$options?.adaptive.isDesktop && this.showNav('search');
          this.isSearchShown = !this.isSearchShown;
        },

        replaceHash(hash) {
          this.$router.replace(cleanObject({
            name: this.$route.name,
            params: this.$route.params,
            query: this.$route.query,
            hash: `#${hash}`
          }));
        },

        requestCode({ action = 'requestCode', request = {}} = {}) {
            return new Promise((resolve, reject) => {
              if (!window.grecaptcha) reject();
                window.grecaptcha.ready(() => {
                  window.grecaptcha.execute('6Lft2EkbAAAAAN1EJWXJvqqBtqzAPCNO3GtTgFNK', { action })
                  .then(token => this.$store.$api.requestCode({ ...request, token }))
                  .then((resp) => {
                    // для случая когда отправляем запрос с протухшим токеном
                    if (resp?.data?.retry) {
                      this.requestCode({ action, request })
                      .then((newResp) => {
                        resolve(newResp);
                      })
                      .catch(() => {
                        reject({
                          error: {
                            detail: 'При получении кода произошла ошибка. Пожалуйста, попробуйте обновить страницу'
                          }
                        })
                      });

                      return;
                    }

                    resolve(resp);
                  })
                  .catch(reject);
                });
              });
          },

          showOldOrderPopup(currentOrderNumber) {
            this.currentOrderNumber = currentOrderNumber;
          this.orderOpened = true;
        },

        hideOldOrderPopup() {
          this.orderOpened = false;
        },
      },
    })
  },
};
